import React, { useMemo, useRef } from 'react'
import { useCallback, useEffect, useState } from 'react'
// export  function WcV2(){
//   var core=useMemo(()=>{
//     return new Core({
//       projectId: '5bc82177524dbba6255674f60b4f80d0',      
//     })
//   },[])

//   var web3walletPromise =useMemo(()=> {
//     return  Web3Wallet.init({
//       core, // <- pass the shared `core` instance
//       metadata: {
//         name: 'Demo app',
//         description: 'Demo Client as Wallet/Peer',
//         url: 'www.walletconnect.com',
//         icons: []
//       }
//     })
//   },[])
//   async function connect(){
//     var web3wallet=await web3walletPromise
//     web3wallet.on('session_proposal', async sessionProposal => {
//       const { id, params } = sessionProposal;
//       console.log({id,params})
//       // ------- namespaces builder util ------------ //
//       const approvedNamespaces = buildApprovedNamespaces({
//           proposal: params,          
//           supportedNamespaces: {
//               eip155: {
//                   chains: ["eip155:1", "eip155:137"],
//                   methods: ["eth_sendTransaction", "personal_sign"],
//                   events: ["accountsChanged", "chainChanged"],
//                   accounts:["eip155:1:0xab16a96d359ec26a11e2c2b3d8f8b8942d5bfcdb","eip155:137:0xab16a96d359ec26a11e2c2b3d8f8b8942d5bfcdb"]
//               },
//           },
//       });
//       // ------- end namespaces builder util ------------ //
  
//       const session = await web3wallet.approveSession({
//           id,
//           namespaces: approvedNamespaces,
//       });
//     })
//     await web3wallet.core.pairing.pair({ uri: wc_uri })
//   }
//   var [wc_uri,set_wc_uri]=useState('')
//   return <div>
//     <input value={wc_uri} onChange={e=>set_wc_uri(e.target.value)}/> 
//     <button onClick={connect}>Connect</button>
//     </div>
// }

import WalletConnect from "@walletconnect/client";
export default function Wc(){
  var [wc_uri,set_wc_uri]=useState('')
  var [address,set_address]=useState('0xa0086991c6218b36c1d19d4a2e9eb0ce3606eb00')
  /** @type {import("@walletconnect/client") } */
  //@ts-ignore
  var connector=useRef(null)?.current

  function connect(){
    var wc=new WalletConnect({
      // bridge: "https://bridge.walletconnect.org", // Required
      uri:wc_uri
    })
    wc.on("session_request", (error, payload) => {
      var x=
        {
            "peerId": "249c7e4c-cbd3-4526-99fd-b66c5e27af98",
            "peerMeta": {
                "description": "MyEtherWallet (MEW) is a free, open-source, client-side interface for generating Ethereum wallets & more. Interact with the Ethereum blockchain easily & securely.",
                "url": "https://www.myetherwallet.com",
                "icons": [
                    "https://www.myetherwallet.com/icons/icon192.png",
                    "https://www.myetherwallet.com/favicon.png",
                    "https://www.myetherwallet.com/img/icons/favicon-32x32.png",
                    "https://www.myetherwallet.com/img/icons/favicon-16x16.png",
                    "https://www.myetherwallet.com/img/icons/apple-touch-icon-152x152.png",
                    "https://www.myetherwallet.com/img/icons/safari-pinned-tab.svg"
                ],
                "name": "MyEtherWallet.com: Your Key to Ethereum"
            },
            "chainId": null
        }
      x=payload?.params?.[0]
      wc.approveSession({ chainId: 1 ,accounts: [address] });
      alert(x.peerMeta?.name + '\n' + x.peerMeta?.description)
    });
    wc.on("call_request", async (error, payload) => {
      alert(JSON.stringify(payload.params))
      var x={
        "id": 1681932259060574,
        "jsonrpc": "2.0",
        "method": "eth_sendTransaction",
        "params": [
            {
                "from": "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
                "to": "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb42",
                "gasPrice": "0x1747b6d75a",
                "gas": "0x5208",
                "value": "0x29a2241af62c0000",
                "nonce": "0x0",
                "data": "0x"
            }
        ]
    }
    x=payload
    })
  }
  return <div>
  <input value={address} onChange={e=>set_address(e.target.value)}/> 
  <input value={wc_uri} onChange={e=>set_wc_uri(e.target.value)}/> 
  <button onClick={connect}>Connect</button>
  </div>
}